import { render } from "./WaitBlockComponent.vue?vue&type=template&id=0cc3ea0c&scoped=true"
import script from "./WaitBlockComponent.vue?vue&type=script&lang=js"
export * from "./WaitBlockComponent.vue?vue&type=script&lang=js"

import "./WaitBlockComponent.vue?vue&type=style&index=0&id=0cc3ea0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0cc3ea0c"

export default script